module.exports = __webpack_public_path__ + "img/bookings_white.25c449ee.svg";